import Http from '../../../http';
import { SET_BARBER_FILTER, SET_METRICS, RESET_DIRTY, SET_DIRTY } from './constants';
import { setProductBreakdown, setServiceBreakdown } from '../breakdown/actions';
import {
  ChurnZeroService,
  RUN_TGS_REPORT,
  RUN_SALES_BY_SERVICE_REPORT,
  RUN_SALES_BY_PRODUCT_REPORT,
  RUN_SALES_BY_BARBER_REPORT,
  RUN_BARBER_SALES_SUMMARY_REPORT,
} from '../../../../modules/infra/observability/churnzero';

export const fetchMetrics = (criteria, metrics) => {
  let url = `/shop/${criteria.shopId}/metrics`;
  if (criteria.brandId) {
    url = `/brand/${criteria.brandId}/metrics`;
  }
  return Http.post(
    url,
    {
      ...criteria,
      metrics,
    },
    true,
    {
      'Squire-Version': '2022-12-05',
    },
  );
};

const setMetrics = metrics => ({
  type: SET_METRICS,
  payload: metrics,
});

const setBarberFilter = payload => ({
  type: SET_BARBER_FILTER,
  payload,
});

export const fetchSalesByBarber = criteria => dispatch => fetchMetrics(criteria, [
  'averagePricePerService',
  'topGrossing',
  'servicesBooked',
  'productsSold',
  'noShowsByBarber',
  'cancellationsByBarber',
  'discounts',
  'tips',
  'barbersWithData',
  'cancellations',
]).then((data) => {
  ChurnZeroService.track(RUN_BARBER_SALES_SUMMARY_REPORT);
  dispatch(setBarberFilter(data.barbersWithData));
  return dispatch(setMetrics(data));
});

export const fetchServiceBreakdown = criteria => dispatch =>
  fetchMetrics(criteria, ['serviceBreakdown'])
    .then(data => dispatch(setServiceBreakdown(data.serviceBreakdown)));

export const fetchProductBreakdown = criteria => dispatch =>
  fetchMetrics(criteria, ['productBreakdown'])
    .then(data => dispatch(setProductBreakdown(data.productBreakdown)));

export const fetchServiceSalesMetric = criteria => dispatch => fetchMetrics(criteria, [
  'serviceSales',
  'serviceItems',
  'barbersWithData',
  'cancellations',
  'noShows',
  'uncharged',
]).then((data) => {
  ChurnZeroService.track(RUN_SALES_BY_SERVICE_REPORT);
  dispatch(setBarberFilter(data.barbersWithData));
  return dispatch(setMetrics(data));
});

export const fetchProductSalesMetric = criteria => dispatch => fetchMetrics(criteria, [
  'productSales',
  'productItems',
  'barbersWithData',
]).then((data) => {
  ChurnZeroService.track(RUN_SALES_BY_PRODUCT_REPORT);
  dispatch(setBarberFilter(data.barbersWithData));
  return dispatch(setMetrics(data));
});

export const fetchForDashboardV2 = criteria => dispatch => fetchMetrics(criteria, [
  'sales',
  'serviceSales',
  'productSales',
  'productItems',
  'serviceItems',
  'barbersWithData',
  'giftCardSales',
  'cancellations',
  'noShows',
  'nextDeposit',
  'lastDeposit',
  'uncharged',
  'grossSalesBreakdown',
]).then((data) => {
  ChurnZeroService.track(RUN_TGS_REPORT);
  dispatch(setBarberFilter(data.barbersWithData));
  return dispatch(setMetrics(data));
});

export const resetDirty = () => ({
  type: RESET_DIRTY,
});

export const setDirty = () => ({
  type: SET_DIRTY,
});

export const fetchSalesByBarberAndShop = criteria => dispatch => fetchMetrics(criteria, [
  'salesByBarberAndShop',
  'productivityByBarber',
  'securedSalesByBarberAndShop',
]).then((data) => {
  ChurnZeroService.track(RUN_SALES_BY_BARBER_REPORT);
  return dispatch(setMetrics(data));
});
